// src/docs/DocsMyProfile.js
import React from "react";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";

const DocsMyProfile = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        My Profile & Viewing Deployed Projects
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        Your profile is the control center on CrowdLaunch where you can view and manage all
        the projects you have deployed. Here you can monitor funding progress, review your project's sale
        status, and perform key management actions.
      </Typography>

      {/* Managing Your Tokenized Projects */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Managing Your Tokenized Projects
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        Once you deploy a project, it appears in your profile with vital details:
        <br />• <strong>Project Name & Share Symbol:</strong> Easily identify your project.
        <br />• <strong>Funding Details:</strong> Track funds raised, token price, soft cap, and hard cap.
        <br />• <strong>Sale Status:</strong> Know if your project is <em>Active</em>, <em>Expired</em>, or <em>Cancelled</em>.
        <br />• <strong>KYC Status:</strong> Check if your project has been verified.
      </Typography>

      {/* Viewing and Actionable Options */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Viewing and Managing Projects
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        In your projects list, click on any project to open the management interface.
        Here you can:
        <br />• Finalize the sale if the project has met the soft cap.
        <br />• Withdraw any remaining shares once the sale is finalized.
        <br />• Cancel the sale if needed.
        <br />• Review detailed metrics including funding progress, token price, and sale end time.
      </Typography>

      {/* Editing Details */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Editing Project Details
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        You can also update certain project details such as your social media links, website URL,
        and KYC information. Pending edits are displayed with a status indicator and require admin
        approval before being finalized.
      </Typography>


      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By using your profile dashboard on CrowdLaunch, you can keep a close eye on your deployed projects,
        make timely management decisions, and update project details as necessary. This centralized hub helps you
        efficiently manage your tokenized projects and ensures you remain in control of your blockchain assets.
      </Typography>
    </Container>
  );
};

export default DocsMyProfile;
